import React from "react";
import { NavLink } from 'react-router-dom';

const Header = ({is_icon_sidebar}) => {
    return(
        <div className="sidenav-header">
            <i 
                className="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none" 
                aria-hidden="true" 
                id="iconSidenav"
            />
            <NavLink className={`navbar-brand ps-4 pe-4 py-${!is_icon_sidebar ? '4' : '3'} m-0`} to="/dashboard">
                <img 
                    src={`/assets/img/${is_icon_sidebar ? 'Instafix-fav.png' : 'instafix-logo-long.png'}`} 
                    className="navbar-brand-img h-100" 
                    alt="main_logo"
                />
                {/* {is_icon_sidebar && <span className="ms-1 text-sm text-success mt-1" style={{fontWeight: "bold"}}>{process.env.REACT_APP_SYSTEM_NAME}</span>} */}
            </NavLink>
        </div>
    );
}

export default Header;